<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
export default {
	mounted: function () {
		this.$store.dispatch('CHECK_LOGIN', this.$route.query)
	}
}
</script>

<style>
@import "assets/css/common.css";
</style>
